import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Mail } from "lucide-react";

const SUPPORT_EMAIL = "Voyes.local@gmail.com";

export function Footer() {
  return (
    <footer className="bg-slate-900 text-white mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2 md:col-span-1">
          <Link to="/" className="flex items-center mb-4">
            <Logo light size="text-3xl" />
          </Link>
          <p className="text-slate-400 text-sm leading-relaxed">
            Calgary's home for local discovery. Find the small businesses, hidden gems and experiences that make your city.
          </p>
        </div>
        <div>
          <h4 className="font-semibold mb-3 text-sm">Discover</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/explore" className="hover:text-orange-400">Explore</Link></li>
            <li><Link to="/events" className="hover:text-orange-400">Events</Link></li>
            <li><Link to="/deals" className="hover:text-orange-400">Deals</Link></li>
            <li><Link to="/map" className="hover:text-orange-400">Map</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3 text-sm">For Business</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/dashboard" className="hover:text-orange-400">List your business</Link></li>
            <li><Link to="/dashboard" className="hover:text-orange-400">Post deals & events</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3 text-sm">Cities</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>Calgary <span className="text-orange-400 text-xs">• Live</span></li>
            <li>Edmonton <span className="text-xs">soon</span></li>
            <li>Vancouver <span className="text-xs">soon</span></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3 text-sm">Support</h4>
          <p className="text-sm text-slate-400 mb-3">Questions or feedback? We'd love to hear from you.</p>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            data-testid="footer-support-email"
            className="inline-flex items-center gap-2 text-sm font-medium text-white bg-white/10 hover:bg-orange-500 transition-colors rounded-full px-4 py-2"
          >
            <Mail className="w-4 h-4" /> {SUPPORT_EMAIL}
          </a>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6 text-center text-sm text-slate-500">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mb-3">
          <Link to="/privacy" className="hover:text-orange-400" data-testid="footer-privacy">Privacy Policy</Link>
          <span className="text-slate-700">·</span>
          <Link to="/terms" className="hover:text-orange-400" data-testid="footer-terms">Terms of Service</Link>
          <span className="text-slate-700">·</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-orange-400" data-testid="footer-support-email-bottom">{SUPPORT_EMAIL}</a>
        </div>
        © 2026 Voyes. Discover Local. Live Local.
      </div>
    </footer>
  );
}
